module.exports = __webpack_public_path__ + "static/img/img9.3de35ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img9.png
// module id = Y2p+
// module chunks = 0